import { CommonModule } from '@angular/common';
import { Component, Input, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';

export enum TextInputType {
  TEXT = 'text',
  PASSWORD = 'password',
  EMAIL = 'email',
  SEARCH = 'search',
  DESCRIPTION = 'description',
}

export enum TextInputVariant {
  FILLED = 'filled', //contained
  OUTLINE = 'outline',
}

export enum TextInputDirection {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export enum TextInputSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum TextInputLabelSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum TextInputWidth {
  FIXED = 'fixed',
  FIXED_DATE = 'fixed-date',
  FULL = 'full',
}

export enum TextInputFieldSpacing {
  'NONE' = 0,
  'X_SMALL' = 8,
  'SMALL' = 16,
  'MEDIUM' = 24,
  'LARGE' = 32,
  'X_LARGE' = 40,
}

@Component({
  standalone: true,
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.css'],
  imports: [CommonModule, FormsModule],
})
export class TextInputComponent {
  value = model('');
  showPassword = signal(false);
  @Input() id!: string;
  @Input() type = TextInputType.TEXT;
  @Input() size = TextInputSize.MEDIUM;
  @Input() labelSize = TextInputLabelSize.MEDIUM;
  @Input() width = TextInputWidth.FIXED;
  @Input() spacingBottom = TextInputFieldSpacing.NONE;
  @Input() direction = TextInputDirection.HORIZONTAL;
  @Input() variant = TextInputVariant.FILLED;
  @Input() placeholder = '';
  @Input() errorMessage!: string;
  @Input() error = false;
  @Input() required = false;
  @Input() testId!: string;
  @Input() label!: string;
  @Input() disabled = false;
  @Input() autoFocus = true;
  InputType = TextInputType;

  togglePassword() {
    this.showPassword.set(!this.showPassword());
    if (this.showPassword()) {
      this.type = TextInputType.TEXT;
    } else {
      this.type = TextInputType.PASSWORD;
    }
  }
}
